// mui
import { Stack, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  description?: string;
  isCentered?: boolean;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}
/**
 * PageHeader shows a title and description for a page.
 */
export const PageHeader = ({
  title,
  description,
  isCentered,
  variant = 'h1',
}: PageHeaderProps) => {
  return (
    <Stack direction='column' spacing={1}>
      <Typography variant={variant} align={isCentered ? 'center' : 'left'}>
        {title}
      </Typography>
      {description && (
        <Typography variant='subtitle1' align={isCentered ? 'center' : 'left'}>
          {description}
        </Typography>
      )}
    </Stack>
  );
};

PageHeader.displayName = 'PageHeader';
export default PageHeader;
